import React, { useEffect, useRef } from 'react'
import { useStoreView } from 'hooks/useStoreView'
import { useProductContext } from 'scenes/Product' // TODO: this should live un app/sofia/hooks
import { FeaturedAttributes } from 'app/sofia/components/FeaturedAttributes'
import { WriteReview } from 'components/Reviews/components/WriteReview'
import { TrustpilotReviews } from 'app/sofia/components/TrustpilotReviews'
import { ReactComponent as DropSvg } from 'resources/svg/icons/drop.svg'
import { DescriptionWrapper, Table, Drops, RowWrapper } from './styled'

interface Props {
  id: number
  productDescription?: string
  absorbency: string
  discreet: string
  overnight: string
  innerLegCuff: string
  customAttributes?: Record<string, any>
}

export const DescriptionTabs: React.FC<Props> = (
  {
    id,
    productDescription,
    absorbency,
    discreet,
    overnight,
    innerLegCuff,
    customAttributes
  }) => {
  const { isSofiaAndGrace } = useStoreView()
  const { descriptionTabOpen } = useProductContext()
  const containerRef = useRef<HTMLDivElement>(null)

  const productSpecsAttributes = [
    'manufacturer',
    'primary_bladder_leakage',
    'padliner_absorbency',
    'underwear_absorbency',
    'pad_length',
    'waist_rise',
    'discreet',
    'color',
    'patterned_design',
    'wings',
    'inner_leg_cuff',
    'individually_wrapped',
    'overnight',
    'reusable',
    'woman_owned',
    'in_store'
  ]

  const productSpecs = customAttributes?.filter((attribute: any) => productSpecsAttributes?.includes(attribute.code)).sort((a: any, b: any) => productSpecsAttributes?.indexOf(a?.code) - productSpecsAttributes?.indexOf(b?.code))

  useEffect(() => {
    if (descriptionTabOpen) {
      const top = (containerRef?.current?.offsetTop)
      window.scrollTo({
        left: 0,
        top,
        behavior: 'smooth'
      })
    }
  }, [
    descriptionTabOpen
  ])

  return (
    <div
      ref={containerRef}
    >
      <RowWrapper>
        <DescriptionWrapper
          title='Description'
          isSofia={isSofiaAndGrace}
        >
          <h2>
            Description
          </h2>
          <div className='content-wrapper'>
            {isSofiaAndGrace && (
              <>
                <div className='featured__wrapper'>
                  <FeaturedAttributes
                    absorbency={absorbency}
                    discreet={discreet}
                    overnight={overnight}
                    innerLegCuff={innerLegCuff}
                  />
                </div>
              </>
            )}
            <div
              dangerouslySetInnerHTML={{
                __html: productDescription ?? ''
              }}
            />
          </div>
        </DescriptionWrapper>

        <div
          className='product__specs'
          title='Product Specs'
        >
          <h2>
            Product Specs
          </h2>
          <Table>
            {productSpecs?.map((spec: any) => {
              const [value] = spec.value
              const isAbsorvencyLevel = spec.code === 'padliner_absorbency' || spec.code === 'underwear_absorbency'

              let specValue = ''
              switch (value) {
                case '':
                  specValue = 'No'
                  break
                case '1':
                  specValue = 'Yes'
                  break
                default:
                  specValue = value
              }

              if ((spec.code === 'woman_owned' && specValue !== 'Yes') || (spec.code === 'in_store' && specValue !== 'No')) { return false }

              return (
                <tr
                  key={spec.label}
                >
                  <td>{spec.label}</td>
                  <td>
                    {isAbsorvencyLevel ? (
                      <Drops>
                        {Array.from(Array(parseInt(value)).keys()).map(drop => (
                          <DropSvg key={drop} />
                        ))}
                      </Drops>

                    ) : (
                      <span>{specValue}</span>
                    )}
                  </td>

                </tr>
              )
            })}
          </Table>
        </div>
      </RowWrapper>

      <div
        title='Reviews'
        className='product__reviews'
      >
        {isSofiaAndGrace ? (
          <>
            <TrustpilotReviews />
          </>
        ) : (
          <WriteReview
            productId={id}
          />
        )}
      </div>
    </div>
  )
}
